import { isChallengePlanUtil } from '../index'
import isLoggedPlanUtil from '../is-logged'
import isRecommendedPlanUtil from '../is-recommended'
import { PLANS_PATH } from '../../../../plans/constants'
import canEditByIdPlanSelector from '../../../../plans/selectors/can-edit-by-id'
import { getIdReduxUtil } from '../../../../redux'

function getDomainListPathPlanUtil (instance, state) {
  if (isChallengePlanUtil(instance)) {
    return PLANS_PATH.CHALLENGES
  }

  if (isLoggedPlanUtil(instance)) {
    return PLANS_PATH.LOGGED
  }

  if (isRecommendedPlanUtil(instance)) {
    return PLANS_PATH.RECOMMENDED
  }

  const canEdit = (
    canEditByIdPlanSelector(
      getIdReduxUtil(instance)
    )(state)
  )

  if (!canEdit) {
    return PLANS_PATH.ALL
  }

  return PLANS_PATH.NON_LOGGED
}

export default getDomainListPathPlanUtil
